// extracted by mini-css-extract-plugin
export default {"card1":"Referral_card1__4-g+h","card2":"Referral_card2__LXdnr","card3":"Referral_card3__aY+kg","card4":"Referral_card4__-fBO9","card5":"Referral_card5__047qO"};